/*=============================================== InputImagePage ===============================================*/

import { useState } from "react"
import { InputImage } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon, inputLabel, validationStatus } from "data"

const InputImagePage = () => {
    const [image, setImage] = useState("")

    const handleImage = (e: any) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
            const reader: any = new FileReader()

            reader.addEventListener("load", () => {
                setImage(reader.result)
            })
            reader.readAsDataURL(e.target.files[0])
        }
    }

    const items: ItemType[] = [
        {
            content: (
                <InputImage
                    id="image"
                    img={image}
                    label="Input image"
                    onChange={e => handleImage(e)}
                    icons={{ empty: "user" }}
                />
            ),
            code: 'const [image, setImage] = useState("")\n\nconst handleImage = e => {\n    if (e.target.files[0]) {\n        setImage(e.target.files[0])\n        const reader: any = new FileReader()\n\n        reader.addEventListener("load", () => {\n            setImage(reader.result)\n        })\n        reader.readAsDataURL(e.target.files[0])\n    }\n}\n\n<InputImage id="image" img={image} label="Input image" onChange={e => handleImage(e)} icons={{ empty: "user" }} />',
            codeTs: 'const [image, setImage] = useState("")\n\nconst handleImage = (e: any) => {\n    if (e.target.files[0]) {\n        setImage(e.target.files[0])\n        const reader: any = new FileReader()\n\n        reader.addEventListener("load", () => {\n            setImage(reader.result)\n        })\n        reader.readAsDataURL(e.target.files[0])\n    }\n}\n\n<InputImage id="image" img={image} label="Input image" onChange={e => handleImage(e)} icons={{ empty: "user" }} />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "img",
            type: "string",
            required: true,
        },
        {
            subtitle: "inputSize",
            type: "string",
            possible: ["small", "large"],
            default: "small",
        },
        validationStatus,
        "separator",
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "empty",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("image"),
        },
        {
            subtitle: "hover",
            type: "string",
            default: iconBoxicon("edit"),
        },
        {
            subtitle: "sizeEmpty",
            type: "number",
            default: 48,
        },
        {
            subtitle: "sizeHover",
            type: "number",
            default: 40,
        },
        ...inputLabel(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default InputImagePage
